import {
    ADD_NEW_POST,
    VIEW_POSTS,
    UPDATE_POST,
    SELECTED_BRAND,
    UPDATE_POST_STATUS,
    SELECTED_POST,
    DELETE_POST,
} from '../constants/action-types/posts';

const initialState = {
    posts: [],
    selectedPost: null,
};

const postsReducer = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_POSTS: {
            return { ...state, posts: action.payload };
        }
        case ADD_NEW_POST: {
            if (state.posts?.length) {
                return { ...state, posts: [...state.posts, action.payload] }
            } else {
                return {...state, posts: [action.payload]};
            }
        }
        case UPDATE_POST: {
            let postIndex = state.posts.findIndex(
                (val) => val._id === action.payload._id
            );
            let updatedPosts = [...state.posts];
            updatedPosts[postIndex] = action.payload;
            return {
                ...state,
                posts: updatedPosts
            }
        }
        case SELECTED_BRAND: {
            return { ...state, selectedBrand: action.payload }
        }
        case UPDATE_POST_STATUS: {
            // Was mutating updatedPosts[postIndex].status in-place — Redux
            // immutability violation that left the same object ref in
            // every place that ever cloned from state.posts (state.user.
            // allPosts, brand.posts). React-Beautiful-DnD then saw the
            // "old" column still containing the dragged card and snapped
            // it back. Also fold queueStatus in so bucketForItem returns
            // the new bucket on the very next render — that's what makes
            // the new column accept the card synchronously.
            const { postId, statusId, queueStatus } = action.payload || {};
            const updatedPosts = (state.posts || []).map((p) =>
                String(p && p._id) === String(postId)
                    ? {
                          ...p,
                          ...(typeof statusId === 'string' ? { status: statusId } : {}),
                          ...(typeof queueStatus === 'string' ? { queueStatus } : {}),
                      }
                    : p
            );
            return {
                ...state,
                posts: updatedPosts,
            };
        }
        case SELECTED_POST: {
            return {
                ...state,
                selectedPost: action.payload,
            }
        }
        case DELETE_POST: {
            // Payload is the bare postId. Drop the matching row so the
            // kanban / list / social-view all re-render without it.
            const removedId = String(action.payload || '');
            return {
                ...state,
                posts: (state.posts || []).filter((p) => String(p && p._id) !== removedId),
            };
        }
        default: return { ...state }
    }
};

export default postsReducer;
